'use client';

import React, { useId } from 'react';
import { cn } from '../lib/utils';
import { SectionTitle } from './typography';

export interface SectionProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** Default grouping: whitespace and type, without a surface boundary. */
export function Section({ title, description, actions, children, className }: SectionProps) {
  const titleId = useId();
  return (
    <section aria-labelledby={titleId} className={cn('min-w-0 space-y-4', className)}>
      <header className="flex min-w-0 flex-wrap items-start gap-x-4 gap-y-3">
        <div className="min-w-0 flex-[1_1_16rem] space-y-2">
          <SectionTitle id={titleId} className="min-w-0 break-normal [overflow-wrap:break-word]">
            {title}
          </SectionTitle>
          {description && (
            <p className="min-w-0 break-words font-body text-body text-text-muted [overflow-wrap:anywhere]">
              {description}
            </p>
          )}
        </div>
        {actions != null && (
          <div className="ml-auto flex min-w-0 flex-[0_1_auto] flex-wrap justify-start gap-2">
            {actions}
          </div>
        )}
      </header>
      <div className="min-w-0 break-words font-body text-body text-text-body [overflow-wrap:anywhere]">
        {children}
      </div>
    </section>
  );
}
